// hooks/useDebouncedState.ts
import { useEffect, useRef, useState } from "react";

export function useDebouncedState<T>(initial: T, delay = 400) {
    const [value, setValue] = useState<T>(initial);
    const [debounced, setDebounced] = useState<T>(initial);
    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => setDebounced(value), delay);
        return () => {
            if (timer.current) clearTimeout(timer.current);
        };
    }, [value, delay]);

    return { value, setValue, debounced };
}
